module.exports = __webpack_public_path__ + "static/img/10.3b28cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/02/10.png
// module id = A75M
// module chunks = 2